/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateLocalizationRequest} from "../model/create-localization-request";
import {ListData} from "../model/list-data";
import {ListLocalizationLanguagesResponse} from "../model/list-localization-languages-response";
import {RefreshImportLocalizationsResponse} from "../model/refresh-import-localizations-response";
import {SuccessResponse} from "../model/success-response";
import {TranslationEditorResource} from "../model/translation-editor-resource";
import {TranslationFilterType} from "../model/translation-filter-type";
import {UploadMediaRequest} from "../model/upload-media-request";

@Injectable({
    providedIn: "root",
})
export class SimLocalizedResourceService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createMissingLocalizations_Url() {
        return super.getUrl(`/api/LocalizedResource/CreateMissingLocalizations`, );
    }

    public downloadLocalizedResources_Url() {
        return super.getUrl(`/api/LocalizedResource/DownloadLocalizedResources`, );
    }

    public getAllLocalizedStrings(language: string) {
        return super.get<{ [key: string]: string; }>(`/api/LocalizedResource/GetAllLocalizedStrings`, {language: language});
    }

    public listLocalizationLanguages() {
        return super.get<ListLocalizationLanguagesResponse>(`/api/LocalizedResource/ListLocalizationLanguages`, );
    }

    public listLocalizedResources(referenceLanguage: string, editLanguage: string, searchTerm: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number, filterType: TranslationFilterType) {
        return super.get<ListData<TranslationEditorResource>>(`/api/LocalizedResource/ListLocalizedResources`, {referenceLanguage: referenceLanguage, editLanguage: editLanguage, searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize, filterType: filterType});
    }

    public migrateLocalization() {
        return super.post<RefreshImportLocalizationsResponse>(`/api/LocalizedResource/MigrateLocalization`, {});
    }

    public migrateLocalizationGet() {
        return super.get<RefreshImportLocalizationsResponse>(`/api/LocalizedResource/MigrateLocalizationGet`, );
    }

    public refreshImportLocalizations() {
        return super.get<RefreshImportLocalizationsResponse>(`/api/LocalizedResource/RefreshImportLocalizations`, );
    }

    public saveLocalizedResource(saveRequest: CreateLocalizationRequest) {
        return super.post<SuccessResponse>(`/api/LocalizedResource/SaveLocalizedResource`, saveRequest);
    }

    public updateJsonFileFromExcel(excelFile: UploadMediaRequest) {
        let formData = this.createFormData(excelFile);
		return super.upload<void>(`/api/LocalizedResource/UpdateJsonFileFromExcel`, formData, {}, [], "events", true);
    }
}